export enum OrderEvents {
  SUBMIT_BUY = 'ORDER:submit_buy',
  SUBMIT_SELL = 'ORDER:submit_sell',
  SUBMIT_BUY_ERROR = 'ORDER:submit_buy_error',
  SUBMIT_SELL_ERROR = 'ORDER:submit_sell_error',
  SUBMIT_BUY_SUCCESS = 'ORDER:submit_buy_success',
  SUBMIT_SELL_SUCCESS = 'ORDER:submit_sell_success',
  CLICKED_CANCEL_ORDER = 'ORDER:clicked_cancel_order',
  CANCEL_ORDER_SUCCESS = 'ORDER:cancel_order_success',
  CANCEL_ORDER_ERROR = 'ORDER:cancel_order_error',
}
